import { TextCollectionResponse } from '@scale/shared/types/response/textcollection';
import { isEmptyResponse } from '@scale/shared/textcollection/helpers';
import { every, isEmpty } from 'lodash';

export const areAllAnnotationsComplete = (
  responses: Record<string, TextCollectionResponse>,
  numCandidates: number,
) => {
  return (
    Object.keys(responses).length > 0 &&
    Object.keys(responses).length === numCandidates &&
    every(responses, r => !isEmpty(r.annotations) && !isEmptyResponse(r))
  );
};
